
import XHeader from 'vux/src/components/x-header/index.vue'


const dataList = [{
docTypeId:1,
docDepth:1,
docTypeName:'基本功能',
docTypePid:'',
checkArticle:0
},{
docTypeId:2,
docDepth:1,
docTypeName:'高级功能',
docTypePid:'',
checkArticle:0
},{
docTypeId:3,
docDepth:2,
docTypeName:'物料的权限分配',
docTypePid:2,
checkArticle:0
},{
docTypeId:4,
docDepth:3,
docTypeName:'一、概述',
docTypePid:3,
checkArticle:1
},{
docTypeId:5,
docDepth:3,
docTypeName:'二、安装与步骤',
docTypePid:3,
checkArticle:1
},{
docTypeId:6,
docDepth:3,
docTypeName:'三、附录',
docTypePid:3,
checkArticle:1
},{
docTypeId:7,
docDepth:1,
docTypeName:'智能（扫描）打印',
docTypePid:'',
checkArticle:0
}]

export default {
components: {
XHeader
},
data () {
return {
cur:0,
wdSwitch:false,
zySwitch:false,
dataList:dataList,
model:{},
menuList:[],
company:{},
}
},
created(){
this. getMenu();
},
methods: {
goBack(){
this.$router.push({
path : '/developer/index',
query : {}
})
},
getPh(index){
this.menuList[index].wdSwitch = !this.menuList[index].wdSwitch
let tempArr = JSON.parse(JSON.stringify(this.menuList))
this.menuList = []
this.$nextTick(() => {
this.menuList = tempArr
})
},
goSearch(){
this.$router.push('search')
},
liClick(e){
if(e.currentTarget.classList.contains("open")){
e.currentTarget.classList.remove("open")
}else{
e.currentTarget.classList.add("open")
}
},
goUrl(i){
if(i.checkOpen==0){
this.$router.push({path:'detail',query:{'docTypeId':i.docTypeId}})
}
if(i.checkOpen==1){
if(this.isLogin()==false){
alert("请先登录")
this.$router.push({path:'/auth/login'})
}else{
this.$router.push({path:'detail',query:{'docTypeId':i.docTypeId}})
}
}
if(i.checkOpen==2){
if(this.company.certStatus==2){
this.$router.push({path:'detail',query:{'docTypeId':i.docTypeId}})
}else{
alert("请先完成公司认证");
}
}

},
getMenu(){
this.$http.post(this.global.httpUrl + '/rest/v1/m/mdoc/getMenus',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success){
this.menuList= res.body.menu;
this.company= res.body.company;
var bin=this.menuList.length;
for(var i=0;i<bin;i++){
this.menuList[i].wdSwitch=false;
}
}
},function(res){
});
},
}
}



// WEBPACK FOOTER //
// ./src/views/doc/docIndex.vue